class ImportFileType {
  public static fileTypeCheck (acceptedType: string[], fileType : string) : string {
    if (!acceptedType.includes(fileType)) {
      const extensions = acceptedType.map(type => type.split('/')[1])

      return 'Type de fichier non supporté. Veuillez sélectionner un fichier avec une extension valide : ' + extensions
    }
    return ''
  }
}

export default ImportFileType
